export default __webpack_public_path__ + "static/Economic Model Update - Vietnam-417f6d455e561c7d36c04671e3dc4ac8.pdf";